// Synonym suggestions from Datamuse (https://www.datamuse.com/api/): free, no API key,
// English. Exact synonyms first, then "means like" words to fill the list.

const DATAMUSE = 'https://api.datamuse.com/words';
const cache = new Map();

export const fetchSynonyms = async (word, limit = 16) => {
  const key = word.toLowerCase();
  if (cache.has(key)) return cache.get(key);
  const query = (params) => fetch(`${DATAMUSE}?${new URLSearchParams({ ...params, max: String(limit) })}`)
    .then((res) => (res.ok ? res.json() : []));
  const [synonyms, similar] = await Promise.all([query({ rel_syn: key }), query({ ml: key })]);
  const seen = new Set([key]);
  const words = [...synonyms, ...similar]
    .map((w) => w.word)
    .filter((w) => w && !seen.has(w) && seen.add(w))
    .slice(0, limit);
  cache.set(key, words);
  return words;
};

/** Keep the replaced word's capitalisation ("Large" -> "Big"). */
export const matchCase = (replacement, original) => {
  if (original === original.toUpperCase() && original.length > 1) return replacement.toUpperCase();
  if (original[0] === original[0].toUpperCase()) return replacement[0].toUpperCase() + replacement.slice(1);
  return replacement;
};
